import { Component, Input, OnInit, HostListener, Inject, ElementRef } from "@angular/core";
import { CourseControllerService } from "./core/controls/course-controller.service";
import { AppConstants } from "./core/vo/app-constants";
import { Router } from "@angular/router";
import { TrackingManager } from "app/core/tracking/tracking-manager";
import { AppServices } from "app/app.services";
import { OrientationService } from "app/services/orientation.service";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { ApplicationModel } from "./core/models/application.model";
import { ApplicationUtilityService } from "./services/application-utility.service";
import { ScreenControllerService } from "./core/controls/screen-controller.service";
import { ModalPopupService } from "./services/modal-popup.service";
import { Subscription } from "rxjs";
import { DescriptorModelService } from "./core/models/descriptor-model.service";
import { GeoLocationModelService } from "./core/views/geolocation/geolocation.model.service";
import { CourseTimerService } from "./services/course-timer.service";
import { DOCUMENT } from "@angular/common";
import { AICC } from './core/tracking/aicc';
import { Scorm } from './core/tracking/scorm';
import { CMI5 } from "./core/tracking/cmi5";
//import { LaunchDarklyService } from "./launch-darkly/launch-darkly.service";
@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["app.component.css", "../assets/navex-styles/all.scss"],
})
export class AppComponent implements OnInit {
	page_inner_wrap = `page-inner-wrap`;
	coursePlayerVersion = "RCP v" + AppConstants.VERSION_NUM;
	public isMobile: Boolean = false;
	public textDirection: string;
	public flowDirection: string;
	private configJsonModelSubscription: Subscription;
	private maxIdleTimeInterval;
	private maxIdleTime;
	private terminateSingleSend;
	private MAX_IDLE_TIMER_INTERVAL = 5;
	private MAX_IDLE_TIMER_TEXT =
		"Your course has been inactive for % minutes and your session has timed out. Please close the course window and launch again to proceed further.";
	private currentTime;
	//private ldInitSubscription: any;
	constructor(
		private _courseController: CourseControllerService,
		private router: Router,
		private appService: AppServices,
		public orientation: OrientationService,
		private modalPopupService: ModalPopupService,
		private descriptorService: DescriptorModelService,
		private appUtilityService: ApplicationUtilityService,
		public _screenController: ScreenControllerService,
		private geoLocationModel: GeoLocationModelService,
		private courseTimerService: CourseTimerService,
		//private ldService:LaunchDarklyService,
    private elRef: ElementRef,
    @Inject(DOCUMENT) private document: Document
	) {
		//Uncomment the below code to get the LaunchDarkly flag values
		/* this.ldInitSubscription = this.ldService.notifier.subscribe(
			(data) => {
				console.log("Launch Darkly data ",data)
			}
		); */
	}

	toggleIW(value: string) {
		this.page_inner_wrap = value;
	}
	public ngOnInit() {
		console.log("Appcomponent ngoninit");
    const isOnIOS = UtilityScripts.isIOSPlatform();
    if(isOnIOS){
      window.addEventListener('pagehide', function (event) {
            window.event.stopPropagation();
          if(TrackingManager.instance.trackingObj instanceof CMI5) {
            TrackingManager.instance.trackingObj.sendTerminateStatement();
          }
        });
      }
		this._courseController.initCourseControllerService();
		//this._courseController.setUpConfigPath();
		//this._courseController.initConfigJsonModel();
		//this._courseController.loadSettingsXML();
		this.appService.toggleLeftMenuEvent$.subscribe((data) => {
			if (data) {
				this.toggleIW(data);
			}
		});
		this.configJsonModelSubscription =
			this.appService.configJSONLoaded$.subscribe((event) => {
					this.initMaxIdleTime(event)
					this.setTerminateOnce(event);
				}
			);
	}
	private setTerminateOnce(event){
		this.terminateSingleSend = event.terminateSingleSend;
	}
	private handleMenuClicked(evt) {
		this._courseController.resetStateSpecificIcon();
	}
	languageUpdate(lang: any): void {
		this._courseController.languageUpdate(lang.language);
		setTimeout(() => { this.textDirection = lang.direction; })
		if (lang.direction === "rtl") {
			this.flowDirection = "right";
		} else {
			this.flowDirection = "left";
		} /*-------Font Embedding for Special Language------------------------------------- */
		if (lang.language === "burmese") {
			UtilityScripts.addStyleTag("assets/css/burmese/embedfont.css");
		} else {
			UtilityScripts.removeStyleTag("assets/css/burmese/embedfont.css");
		}
		/*-------Font Embedding for Special Language------------------------------------- */
		if (lang.language === "bengali") {
			UtilityScripts.addStyleTag("assets/fonts/bengali/bengalifont.css");
		} else {
			UtilityScripts.removeStyleTag("assets/fonts/bengali/bengalifont.css");
		}
		if (lang.language === "nepali") {
			UtilityScripts.addStyleTag("assets/fonts/nepali/nepalifont.css");
		} else {
			UtilityScripts.removeStyleTag("assets/fonts/nepali/nepalifont.css");
		}
	}
	languageUpdateByDropDown(lang: string): void {
		this._courseController.languageUpdateFromDropdown(lang);
		/*-------Font Embedding for Special Language------------------------------------- */
		if (lang === "burmese") {
			UtilityScripts.addStyleTag("assets/css/burmese/embedfont.css");
		} else {
			UtilityScripts.removeStyleTag("assets/css/burmese/embedfont.css");
		}
		/*-------Font Embedding for Special Language------------------------------------- */
		if (lang === "bengali") {
			UtilityScripts.addStyleTag("assets/fonts/bengali/bengalifont.css");
		} else {
			UtilityScripts.removeStyleTag("assets/fonts/bengali/bengalifont.css");
		}
		if (lang === "nepali") {
			UtilityScripts.addStyleTag("assets/fonts/nepali/nepalifont.css");
		} else {
			UtilityScripts.removeStyleTag("assets/fonts/nepali/nepalifont.css");
		}
	}
	updateAudioMode(audioOn: boolean): void {
		this._courseController.audioUpdate(audioOn);
	}

	public updatePresMode(pMode: string) {
		this._courseController.presentationModeUpdate(pMode);
	}
	public updatePresModebyPopup(pMode: string) {
		this._courseController.presentationModeUpdateByPopup(pMode);
	}

	public closeSidebarNav(value: string) {
		this.toggleIW(value);
	}

	@HostListener("window:beforeunload", ["$event"])
	public async beforeunloadHandler(event) {
     if(UtilityScripts.isFF()){
      event.preventDefault();
    }
     console.log("before unload handler called******")
		if (!this.appUtilityService.isPlayerWindowUnloaded) {
			if (TrackingManager.instance.trackingObj instanceof AICC) {
				AppConstants.isExiting = true;
				TrackingManager.instance.trackingObj.doFinish();
			} else if(TrackingManager.instance.trackingObj instanceof CMI5) {
				TrackingManager.instance.trackingObj.sendTerminateStatement();
			} else if (TrackingManager.instance.trackingObj instanceof Scorm && this.terminateSingleSend){
				(window as any).handleFinish();
			}
		}
	}

  @HostListener("document:keydown", ["$event"])
  public tabKeyPress(e) {
    this.appService.keyPressEvent(e);
  }

  public getAppModel() {
    return ApplicationModel.instance;
  }

  private initMaxIdleTime(event) {
    this.currentTime = 0;
    this.maxIdleTime = event.maxIdle;
    if(this.maxIdleTime > 0){
      this.maxIdleTimeInterval = setInterval(() => {
        this.currentTime+=this.MAX_IDLE_TIMER_INTERVAL;
        if(this.currentTime >= this.maxIdleTime*60){
          this.closePlayer();
        } 
      }, this.MAX_IDLE_TIMER_INTERVAL*1000);
    }
  }
  public mouseUp(){
    if(this.maxIdleTime > 0){
      this.currentTime = 0;
    }
  }
  public closePlayer(){
    clearInterval(this.maxIdleTimeInterval);
    let maxIdealTimeoutText = (UtilityScripts.removeHTMLTags(this.descriptorService.getDescriptorTextById('maxIdleTimeout'))?UtilityScripts.removeHTMLTags(this.descriptorService.getDescriptorTextById('maxIdleTimeout')):this.MAX_IDLE_TIMER_TEXT)
    let arrMaxIdleTimeout = maxIdealTimeoutText.split("%");
    let popupdata = {
      size: 'lg',
      isMaxIdlePopup: true,
      title:"",
      body: arrMaxIdleTimeout[0]+this.maxIdleTime+arrMaxIdleTimeout[1],
     }; 
    try{
      this.modalPopupService.closePopup();
    } catch(e){}
    try{
      this.geoLocationModel.showGeoLocation = false;
    } catch(e){}
    try{
      let videoOverlay:any = document.getElementsByClassName("autoVideoPlayBtn")[0]
      videoOverlay.style.display = "none";
    } catch(e){}    
    try{
      let audioOverlay:any = document.getElementsByClassName("autoPlayBtn")[0]
      audioOverlay.style.display = "none"
    } catch(e){}  
    this.appService.onMaxIdleTimeReached();
    this.courseTimerService.disposeTimer();
    this._courseController.bShowPopup = false;
    this.orientation.end();
    let introjsSkipBtn:any = document.getElementsByClassName('introjs-skipbutton')[0]
    if(introjsSkipBtn){introjsSkipBtn.click();}
    const os:string = UtilityScripts.getSystemDetails()["os"].toLowerCase();
    if(os.indexOf("ios") != -1 ||  os.indexOf("android") != -1 ){
      setTimeout(() => {
        this.modalPopupService.openDialogPopup(popupdata);  
      },2000)
    } else {
      this.modalPopupService.openDialogPopup(popupdata);
    }
  }

  public handleSkipTo(query: string, e) {
    e.preventDefault();
    const htmlElement = this.elRef.nativeElement.querySelector(query);
    if (htmlElement) {
      htmlElement.focus();
    }
  }
  private closeOrientation() {
    this._courseController.orientation.end();
    if (document.getElementById("videoPlayButton")) {
      document.getElementById("videoPlayButton").focus();
    }
    if (document.getElementById("audioPlayButton")) {
      document.getElementById("audioPlayButton").focus();
    }
  }
}